module.exports = __webpack_public_path__ + "static/media/Colette Super King Bed Base - 200x210 cm_Burnt Orange.7907d4d1.png";